// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.register_provider ul.nav-tabs {\n    width: 100%;\n    background: transparent;\n}\n.register_provider ul.nav-tabs li {\n    width: 33.33%;\n}\n.register_provider ul.nav-tabs li a {\n    border: none;\n}\n.register_provider .nav-link.active {\n    border-bottom: 2px solid #fff;\n    background: transparent;\n}\n.register_provider .nav-link.active .head_register-list {\n    color: #fff;\n}\n.invisible {\n    display: none;\n}\n", ""]);
// Exports
module.exports = exports;
